import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "row justify-content-center" }
const _hoisted_2 = { class: "col-12 text-center" }
const _hoisted_3 = {
  key: 0,
  class: "row d-flex justify-content-center"
}
const _hoisted_4 = { class: "col-1 mt-3 mb-3" }
const _hoisted_5 = { class: "progress-spinner progress-spinner-double size-sm progress-spinner-active" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "progress-spinner-inner" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "progress-spinner-inner" }, null, -1)
const _hoisted_8 = { class: "visually-hidden" }
const _hoisted_9 = {
  key: 1,
  class: "row justify-content-center"
}
const _hoisted_10 = {
  key: 0,
  class: "col-12"
}
const _hoisted_11 = ["onClick"]

import { onMounted, ref, inject, onUnmounted, watch } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "../../models/Store/store";
import { useTenantConfig } from "../../composables/useTenantConfig";
import api from "@/services/BookingService";
import _ from "lodash";
import moment from "moment";
import { AxiosError } from "axios";
import { MonthAvailable } from "@/models/Step/MonthAvailableModel";
import { useI18n } from "vue-i18n";
import constants from "@/models/Utils/constants";


export default /*#__PURE__*/_defineComponent({
  __name: 'BookMonth',
  setup(__props) {

const { getWebDelayDaysForLocation } = useTenantConfig();
const router = useRouter();
const store = useStore();
const { t } = useI18n();
const emitter = inject("emitter");

const selectedItem = ref(null);
const loadingMonths = ref(false);
const monthAvailables = ref([]);

const spacing = ref(t("settings.spacing"));

onMounted(() => {
  store.stepsMade.month = null;

  const localeCode = t("settings.localeCode");
  moment.locale(localeCode);

  emitter.on(constants.GO_NEXT_STEP, () => {
    console.log("received goNextStep BookMonth");
    goToNextStep();
  });

  if (
    _.isNull(store.stepsMade) === false &&
    _.isNull(store.stepsMade.service) === false &&
    _.isNull(store.stepsMade.location) === false
  ) {
    getData();
  }
});

watch(
  () => selectedItem.value,
  (newVal) => {
    if (newVal) {
      //emitter.emit(constants.CAN_GO_NEXT_STEP, true);
      goToNextStep();
    } else {
      emitter.emit(constants.CAN_GO_NEXT_STEP, false);
    }
  },
  { immediate: true }
);

const getData = () => {
  loadingMonths.value = true;
  const delayDays = getWebDelayDaysForLocation(store.stepsMade.location.id);
  let friendlyCodeEditing = null;
  if (store.bookedit) {
    friendlyCodeEditing = store.bookedit.friendlyCode;
  }

  api
    .getAvailableMonths(
      store.tenantSelected.id,
      store.stepsMade.location.id,
      parseInt(store.stepsMade.service.id),
      delayDays,
      "web",
      friendlyCodeEditing
    )
    .then((response) => {
      if (_.isNull(response) === false && _.isUndefined(response) === false) {
        if (
          _.isNull(response.data) === false &&
          _.isUndefined(response.data) === false
        ) {
          if (
            _.isArray(response.data.monthAvailables) &&
            response.data.monthAvailables.length > 0
          ) {
            let monthResponse = response.data.monthAvailables;
            monthResponse.forEach((m) => {
              m.monthName = _.upperFirst(m.monthName);
            });
            monthAvailables.value = monthResponse;

            loadingMonths.value = false;
          } else {
            loadingMonths.value = false;
          }
        }
      }

      loadingMonths.value = false;
    })
    .catch((err: AxiosError) => {
      console.log("Errore nella get dei mesi");
      loadingMonths.value = false;
    });
};

const selectedMonth = (item: MonthAvailable) => {
  if (_.isNull(item) === false && _.isUndefined(item) === false) {
    const monthStep = new MonthAvailable();
    monthStep.id = item.id;
    monthStep.month = item.month;
    monthStep.monthName = item.monthName;
    monthStep.year = item.year;
    monthStep.name = item.monthName + " " + item.year;
    selectedItem.value = monthStep;
  }
};

const goToNextStep = () => {
  store.stepsMade.month = selectedItem.value;
  router.push({ name: "bookday" });
};

const isItemSelected = (item: MonthAvailable) => {
  if (_.isNull(selectedItem.value) === false) {
    if (selectedItem.value.month === item.month) {
      return true;
    }
  }
  return false;
};

const bookEditHasSameMonth = (item: MonthAvailable) => {
  if (_.isNull(store.bookedit) === false) {
    const date = moment(store.bookedit.fromDate);
    const monthFromPreviousValue = date.month() + 1;

    if (monthFromPreviousValue === item.month) {
      return true;
    }
  }
  return false;
};

onUnmounted(() => emitter.off(constants.GO_NEXT_STEP));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h2", null, _toDisplayString(_unref(t)("titles.selectBookingMonth")), 1)
      ])
    ]),
    (loadingMonths.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _hoisted_7,
              _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(t)("common.loadingText")), 1)
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_9, [
          (monthAvailables.value.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("label", null, [
                  _createElementVNode("b", null, _toDisplayString(_unref(t)("messages.noAvailability")), 1)
                ])
              ]))
            : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(monthAvailables.value, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "col-12 col-md-6 col-xl-4 d-grid gap-2",
                  key: item.id
                }, [
                  _createElementVNode("button", {
                    type: "button",
                    class: _normalizeClass(["btn btn-lg my-3", [
            isItemSelected(item) ? 'btn-primary ' : 'btn-outline-primary ',
          ]]),
                    onClick: ($event: any) => (selectedMonth(item))
                  }, [
                    _createElementVNode("div", null, _toDisplayString(item.monthName) + " " + _toDisplayString(spacing.value) + " " + _toDisplayString(item.year), 1)
                  ], 10, _hoisted_11)
                ]))
              }), 128))
        ]))
  ]))
}
}

})